module.exports = __webpack_public_path__ + "img/ico-save-blue.93ebb07a.svg";